module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal-dialog modal-lg" role="document">\n    <div class="modal-content">\n        <div class="modal-header">\n            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n            <h4 class="modal-title" id="myModalLabel">'+
((__t=( title ))==null?'':__t)+
'</h4>\n        </div>\n        <div class="modal-body">\n            <div id="fp_modal_gallery" class="carousel slide" data-ride="carousel">\n                <ol class="carousel-indicators">\n                    ';
 imgs.forEach(function(img, i) { 
__p+='\n                    <li data-target="#fp_modal_gallery" data-slide-to="'+
((__t=( i ))==null?'':__t)+
'" ';
 if (i === idx) { 
__p+='class="active"';
 } 
__p+='></li>\n                    ';
 }) 
__p+='\n                </ol>\n                <div class="carousel-inner" role="listbox">\n                    ';
 imgs.forEach(function(img, i) { 
__p+='\n                    <div class="'+
((__t=( 'item' + (i === idx ? ' active' : '') ))==null?'':__t)+
'">\n                        <img src="'+
((__t=( img.full ))==null?'':__t)+
'">\n                        ';
 if (img.caption) { 
__p+='\n                        <div class="carousel-caption">\n                            <h3>'+
((__t=( img.caption ))==null?'':__t)+
'</h3>\n                        </div>\n                        ';
 } 
__p+='\n                    </div>\n                    ';
 }) 
__p+='\n                </div>\n                <a class="left carousel-control" href="#fp_modal_gallery" role="button" data-slide="prev">\n                    <span class="icon-prev" aria-hidden="true"></span>\n                    <span class="sr-only">Previous</span>\n                </a>\n                <a class="right carousel-control" href="#fp_modal_gallery" role="button" data-slide="next">\n                    <span class="icon-next" aria-hidden="true"></span>\n                    <span class="sr-only">Next</span>\n                </a>\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};
